module.exports = __webpack_public_path__ + "static/header6-2dbc56af3df60c9909f66d17c12d0e65.png";